<template>
  <v-app>
    <Navigation/>
    <v-main class="content">
      <router-view></router-view>
    </v-main>
    <BannerFooter/>
    <v-footer
      color="primary"
      height="auto"
    >
      <v-container>
        <v-row align="center">
          <v-col>
            <div
              class="text-center white--text"
            >Copyright &copy; {{ year }} HealthView Capital Partners. All Rights Reserved.</div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Navigation from '@/components/core/Navigation'
import BannerFooter from '@/components/core/BannerFooter'

export default {
  name: 'App',
  components: {
    Navigation,
    BannerFooter,
  },
  metaInfo: {
    title: 'HealthView Capital',
    titleTemplate: '%s | HealthView Capital',
  },

  computed: {
    year() {
      const date = new Date()
      return date.getFullYear()
    },
  },
}
</script>
